import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/categories/actions';
import * as os from 'osutil';
import {Card, CardTitle} from 'material-ui/Card';

class CategoryGrid extends Component {
  state = { };

  style = {
    width: 300,
    cursor: "pointer",
  }

  static contextTypes = {
    router: PropTypes.object
  };


  componentWillMount() {
    this.props.fetchCategories();//(this.props.params.id);
  }
  
  handleClick = (key) => {
    var url = "/media/"+this.props.brandid+"/"+key;
    this.context.router.history.push(url);
  }

  renderCategories() {
    return _.map(this.props.categories, (cat, key) => {
      return (
        <Card key={key} className="card" style={this.style} onClick={this.handleClick.bind(this,cat.key)}>

          <div className="card__themeimage" >
            <img  alt="" src={cat.themeimageUrl} />
            <div className="card__themeimage_overlay" ></div>
          </div>
          
          <CardTitle title={cat.name} />
          
            <div className="card__text">
              {cat.targetgroup}
            </div>

        </Card>
      )
    });
  }

  
  render() {

    return (
      <div className="categorygrid">
        {this.renderCategories()}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {

  if (!state || !state.categories.list.data )
  {
    return {};
  }

  var _categories = os.collection_by_keys(state.categories.list.data, Object.keys(ownProps.categories));
  var categories = _.map(ownProps.brand.categories, (c, key) => {
    if (!c.disabled)
      {   
        var category = os.remove_empty(c);
        var override =state.categories.list.data[c.categoryid]
        var result = { ...override, ...category, key:key};
        return result ;
      }
    } );
    
  return {
    categories: categories,
  };
}

export default connect(mapStateToProps, actions)(CategoryGrid)

  



// WEBPACK FOOTER //
// ./src/pages/channels/CategoryGrid.jsx